import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestSection() {
  const latestArticles = articles.filter((a) => !a.isHot).slice(0, 6);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新吃瓜
            </h2>
            <p className="text-sm text-foreground-500 mt-1">24小时实时更新，不错过任何一个瓜</p>
          </div>
          <Link
            to="/category/zuixin-chigua"
            className="hidden sm:flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/zuixin-chigua"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}